<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{params.title}}</div>
    <div slot="body">
      <dialog-selected-tips :name="params.name" :count="params.data.length" :action="params.title" />
      <dialog-table class="mb-2" :data="params.data" :columns="params.columns" />
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('op_30')" v-bind="formItemLayout">
          <base-select
              v-decorator="decorators.sku_service_id"
              class="w-100"
              :filterable="true"
              :isDefaultSelect="true"
              needParams
              resource="billing_sku_services"
              :params="skuServicesParams" />
        </a-form-item>
        <a-form-item :label="$t('op_39')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.name" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'UpdateSkuSubcategoryDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        sku_service_id: [
          'sku_service_id',
          {
            initialValue: this.params.data[0].sku_service_id,
            rules: [
              { required: true, message: this.$t('op_42') },
            ],
          },
        ],
        name: [
          'name',
          {
            initialValue: this.params.data[0].name,
            rules: [
              { required: true, message: this.$t('op_41') },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      skuServicesParams: {
        scope: this.scope,
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo']),
  },
  methods: {
    doCreate (data) {
      return this.params.onManager('update', {
        id: this.params.data[0].id,
        managerArgs: {
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doCreate(values)
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
